import { createStyles, makeStyles } from '@material-ui/core';
import { styled } from '@mui/material';

export const Button = styled('button')({
  borderRadius: '40px',
  background: '#004357',
  color: '#fff',
  padding: '0.4rem 1.5rem 0.5rem',
});

const useStyles = makeStyles(() =>
  createStyles({
    headerSelectorCont: {
      position: 'absolute',
      right: 0,
      backgroundColor: '#fff',
      zIndex: 10,
      borderRadius: '8px',
      boxShadow:
        'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em',
    },
    headerSelectorSearch: {
      position: 'relative',
      borderBottom: '1px solid #e0e0e0',

      '& input': {
        border: 'transparent',
        outline: 'none',
        padding: '10px',
        fontFamily: 'inherit',
        paddingRight: '20px',
      },

      '& svg': {
        position: 'absolute',
        right: 5,
        top: '7px',
      },
    },
    headersDataList: {
      maxHeight: '180px',
      overflow: 'auto',
      scrollbarWidth: 'none',

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    headersDataItem: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: '1rem',
    },
    headersNoData: {
      width: '100%',
      height: '50px',
      display: 'grid',
      placeItems: 'center',
    },
    filterLogCont: {
      display: 'grid',
      gridTemplateColumns: '1fr 100px',
      alignItems: 'center',
      gap: '1rem',
      marginTop: '2rem',
    },
    filterGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: '1rem',
    },

    headerAbsolute: {
      position: 'absolute',
      right: 0,
      top: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
  })
);

export default useStyles;
